import Modal from "@/components/ui/modal";
import UpdateProfile from "../update-profile";

const UpdateProfileModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
	return (
		<Modal isOpen={isOpen} onClose={onClose} className="max-w-4xl p-0 md:p-0">
			<UpdateProfile />
		</Modal>
	);
};

export default UpdateProfileModal;
